module.exports = __webpack_public_path__ + "static/img/logob.e2fc695.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/logob.png
// module id = AweK
// module chunks = 2